import { request } from './createRequest';
import { FetchFullAvailabilityRequest, FetchFullAvailabilityResponse } from './types';

export const fetchFullAvailability = (
  requestBody: FetchFullAvailabilityRequest
): Promise<FetchFullAvailabilityResponse> => {
  return request.post('/v3/availability/fetch-full', requestBody).then((res) => ({ status: res.status }));
};
